// extracted by mini-css-extract-plugin
module.exports = {"newCamera":"QRScanner_newCamera__Daos4","loadingCamera":"QRScanner_loadingCamera__2EK8J"};